import { useQueryClient } from '@tanstack/react-query';
import type { ContentObject, ContentObjectList, EventContentObjectDetail, EventContentObjectList } from 'models';
import { useCallback } from 'react';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Break circular dependency
import { updateBookmarkInFeeds, updateBookmarksFeed } from 'features/bookmark/utils';
// eslint-disable-next-line @typescript-eslint/no-restricted-imports -- Break circular dependency
import { getContentObjectId } from 'features/feed/utils';
import type { ProgramEventLayoutQueryData } from '../queries';
import { getEventDetailQueryKey, getProgramEventLayoutQueryKey } from '../queries/keys';

export const useUpdateEventBookmark = () => {
  const queryClient = useQueryClient();

  return useCallback(
    (params: { contentObject: EventContentObjectDetail | EventContentObjectList }) => {
      const isBookmarked = !params.contentObject.bookmarked;

      queryClient.setQueriesData<ContentObject>(
        { queryKey: getEventDetailQueryKey({ id: params.contentObject.event.id }) },
        (event) => {
          if (!event) {
            return event;
          }

          return { ...event, bookmarked: isBookmarked };
        },
      );

      queryClient.setQueryData<ProgramEventLayoutQueryData>(
        getProgramEventLayoutQueryKey({ id: params.contentObject.event.id }),
        (event) => {
          if (!event || 'nodeId' in event) {
            return event;
          }

          return { ...event, bookmarked: isBookmarked };
        },
      );

      const id = getContentObjectId(params.contentObject);

      updateBookmarkInFeeds({ id, isBookmarked, queryClient });
      updateBookmarksFeed({
        id,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion -- TODO: fix, ContentObjectList doesn't cover all rails content object types yet
        insertableItem: { ...params.contentObject, bookmarked: isBookmarked } as unknown as ContentObjectList,
        isBookmarked,
        queryClient,
      });
    },
    [queryClient],
  );
};
